import { render, staticRenderFns } from "./LabelManagement.vue?vue&type=template&id=5c868b28&scoped=true"
import script from "./LabelManagement.vue?vue&type=script&lang=js"
export * from "./LabelManagement.vue?vue&type=script&lang=js"
import style0 from "./LabelManagement.vue?vue&type=style&index=0&id=5c868b28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c868b28",
  null
  
)

export default component.exports